export default __webpack_public_path__ + "static/media/termo.5a50237e.pdf";